define('modules/editor/models/property_groups/page_notification',['require','exports','module','./base'],function(require,exports,module){
  "use strict";
  var BasePropertyGroup = require("./base");
  module.exports = BasePropertyGroup.extend({
    name: "page:notification",
    properties: ["active", "message", "linkUrl", "linkText", "title"],
    defaults: {
      "active": false,
      "message": "",
      "linkUrl": "",
      "linkText": ""
    },
    validators: {
      "linkUrl": function(attrs){
        return attrs.linkUrl === "" || this.isValidUrl(attrs.linkUrl) || this.isValidAnchorName(attrs.linkUrl);
      }
    }
  });
});

